// Modules
import React from 'react';

// Style
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

const ErrorFallback = ({ error }) => (
    <Grid item container className="main-body">
        <Grid item xs={12} lg={8} className="main-body">
            <h1>Something went wrong....</h1>
            <p>
                The requested page cannot be displayed. Please try again later
                while we work to correct the issue.
            </p>

            <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.reload()}
            >
                Reload this page
            </Button>

            <p>Or, click below to go back to the home page.</p>
            <Button
                variant="contained"
                color="primary"
                onClick={() => window.location.assign('/ephtportal')}
            >
                Take Me Home!
            </Button>

            {/* Only want to display error details on development */}
            {process.env.NODE_ENV.toLowerCase() === 'development' && (
                <>
                    <pre>{error.message}</pre>

                    <details className="content-block">
                        <summary>Click for error details</summary>
                        {error.toString()}
                    </details>
                </>
            )}
        </Grid>
    </Grid>
);

export default ErrorFallback;
